import { Component, OnInit, Input } from '@angular/core';
import { ModalSidebarService } from '../modal-sidebar/modal-sidebar.service';

@Component({
  selector: 'app-card-icon',
  templateUrl: './card-icon.component.html',
  styleUrls: ['./card-icon.component.scss']
})
export class CardIconComponent implements OnInit {

  @Input() cardIconUrl: any = '';
  @Input() cardTitle: any = '';
  @Input() cardDescription: any = '';
  @Input() cardDescriptionFull: any = '';
  @Input() cardLink: any = '';
  @Input() minimal: boolean = false;

  constructor(public modalSidebar: ModalSidebarService) { }

  ngOnInit(): void {
  }

  showModal(title, descriptionFull) {
    let cardInfo = {
      title: title,
      description: descriptionFull
    }
    
    this.modalSidebar.setModalData(cardInfo, true);
  }

}
